import type { ReactNode } from "react";

interface VaultLayoutProps {
  sidebar: ReactNode;
  main: ReactNode;
  rightPanel?: ReactNode;
}

export function VaultLayout({ sidebar, main, rightPanel }: VaultLayoutProps) {
  return (
    <div className="flex h-full min-h-0 overflow-hidden bg-background">
      {sidebar}
      {main}
      {rightPanel}
    </div>
  );
}
